var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8.5V12.25C13.75 12.94 13.19 13.5 12.5 13.5H1.5C0.81 13.5 0.25 12.94 0.25 12.25V8.5H1.75V12.25H12.25V8.5H13.75ZM7.75 8.19L11.53 4.41L12.59 5.47L7 11.06L1.41 5.47L2.47 4.41L6.25 8.19V0.5H7.75V8.19Z",
    fill: "#007BFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-download.4f2eed40.svg";
export { ForwardRef as ReactComponent };